/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import type { BRAND_ABRV } from '$lib/utilities/brandingConfigurations';
import { derived, writable } from 'svelte/store';

export type ChatSessionData = {
    conversation_id: string;
    agent: 'flora' | 'sierra' | 'decagon';
    token: string;
    auth: boolean;
    deviceType: string;
    operatingSystem: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    flags: Record<string, any>;
    firstName: string;
    lastName: string;
    channel: string;
    entry_point: string;
    entry_page_type: string;
    brand: BRAND_ABRV;
    email: string;
    contactId: string;
    enterpriseId: string;
    browseruuid: string;
    loyaltyStatus: string;
    passportEndDate: string;
    parentViewPortHeight: string,
    currentUrl: string;
    transferCounter: number;
    cartOrderDetails: {
        isItemAdded: string;
        orderValue: string;
        orderNumber: string;
        wasOrderPlaced: string;
        cartHasPassport: string;
    };
    messages: {
        sender: string;
        message: string;
        type: string;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        params?: Record<string, any>;
    }[]
    chatHistory: {
        sender: string;
        message: string;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        params: Record<string, any>
    }[];
    disconnectTimer: ReturnType<typeof setInterval> | null;
    reconnectAttempts: number;
    reconnectFailureMessageSent: boolean;
}
export const chatSession = writable<ChatSessionData>({
    conversation_id: '',
    token: '',
    auth: false,
    deviceType: '',
    operatingSystem: '',
    agent: 'flora',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    flags: {} as Record<string, any>,
    firstName: '',
    lastName: '',
    brand: '18F' as BRAND_ABRV,
    channel: 'desktop_web',
    entry_point: 'global',
    entry_page_type: '',
    email: '',
    contactId: '',
    enterpriseId: '',
    browseruuid: '',
    loyaltyStatus: '',
    passportEndDate: '',
    parentViewPortHeight: '',
    currentUrl: '',
    transferCounter: 0,
    cartOrderDetails: {
        isItemAdded: '',
        orderValue: '',
        orderNumber: '',
        wasOrderPlaced: '',
        cartHasPassport: ''
    },
    messages: [] as {
        sender: string;
        message: string;
        type: string;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        params?: Record<string, any>;
    }[],
    chatHistory: [] as {
        sender: string;
        message: string;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        params: Record<string, any>
    }[],
    disconnectTimer: null,
    reconnectAttempts: 0,
    reconnectFailureMessageSent: false
});
export const is_start_loading = writable<boolean>(false);
export const reInitializeChat = writable(false);
export const entryMessage = writable({ suggestion: '', type: '' });
export const chatVisible = writable(false);
export const chatVisibleStateListener = derived(chatVisible, ($chatVisible) => $chatVisible);
export const isChatSessionReady = derived(chatSession, ($chatSession) => !!$chatSession.token);
export const chatPreviewMsgVisible = writable(true);
export const chatPreviewMsgVerbiage = writable('')
export const suggestionMessage = writable('');
export const chatHeaderButtonClicked = writable(false);
export const chatTriggeredExternally = writable(false);
export const messageLoading = writable(false);
export const surveySent = writable(false);
export const sessionTimeout = writable(false);
export const conversationTimeout = writable(false);
export const notificationSoundEnabled = writable(true);
export const connectedToAgent = writable(false);
export const chatStartTime = writable('');
export const virtualAgentDisconnectMessageSent = writable(false);
export const persistentSessionData = writable({ operatingSystem: '', allowedDeviceTypes: [] as string[] });
export const displayDisconnectWarning = writable(false)
export const displayDisconnect = writable(false)

export const updateSessionStorage = async (sessionData: ChatSessionData) => {
    sessionStorage.setItem('conversation', JSON.stringify(sessionData));
};
